import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../../../useApiQuery';

const useGetMarketplaceHostProfiles = ({ showId: showIdParam, disabled } = {}) => {
  const { showId: currentShowId } = useParams();
  const showId = showIdParam || currentShowId;

  const query = useApiQuery({
    queryKey: keys.hostProfiles({ showId }),
    requestUrl: `/shows/${showId}/marketplace/profiles/hosts`,
    disabled: disabled || !showId,
  });

  return {
    hostProfiles: query.data,
    hostProfilesError: query.error,
    isHostProfilesFetchError: query.isError,
    isHostProfilesFetchSuccess: query.isSuccess,
    isHostProfilesFetching: query.isFetching,
    isHostProfilesLoading: query.isInitialLoading,
    refetchHostProfiles: query.refetch,
    ...query,
  };
};

export default useGetMarketplaceHostProfiles;
